<app-page-base>
  <p-card>
    <ng-template #header>
      <div class="p-card-title p-4 text-lg font-bold">
        {{ 'loggedUser' | translate }}
      </div>
    </ng-template>

    <p-tabs class="min-h-104" [(value)]="tabsId">
      <p-tablist>
        <p-tab [value]="0">{{ 'data' | translate }}</p-tab>
        <p-tab [value]="1">{{ 'configuration' | translate }}</p-tab>
        <p-tab [value]="2">Password</p-tab>
        <p-tab [value]="3">{{ 'consents.consents' | translate }}</p-tab>
        <p-tab [value]="4">{{ 'functionality' | translate }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel [value]="0">
          <div class="grid grid-cols-5 items-center gap-3">
            <label class="col-1 text-left" for="user-id">{{ 'userId' | translate }}</label>
            <input pInputText id="user-id" class="col-span-2" [(ngModel)]="user.id" [disabled]="true" />

            <label class="col-1 text-left" for="user-name">UserName/E-Mail</label>
            <input pInputText id="user-name" class="col-span-2" [(ngModel)]="user.userName" [disabled]="true" />

            <label class="col-1 text-left" for="display-name">{{ 'name' | translate }}</label>
            <input pInputText id="display-name" class="col-span-2" [(ngModel)]="user.name" />

            <label class="col-1 text-left" for="family-name">{{ 'surname' | translate }}</label>
            <input pInputText id="family-name" class="col-span-2" [(ngModel)]="user.familyName" />
          </div>
        </p-tabpanel>

        <p-tabpanel [value]="1">
          <div class="grid grid-cols-5 content-start gap-3">
            <div class="col-1 flex flex-col">
              <label class="text-left font-semibold">{{ 'roles' | translate }}</label>
              <p-table [value]="ruoli"
                       stripedRows
                       size="small">
                <ng-template #body let-role>
                  <tr>
                    <td>{{ role | translate }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
            <div class="col-span-2 flex flex-col">
              <label class="text-left font-semibold">{{ 'organizations' | translate }}</label>

              <p-table [value]="user.organizations"
                       dataKey="organizationId"
                       stripedRows
                       [expandedRowKeys]="expandedRows"
                       size="small">
                <ng-template #body let-organization let-expanded="expanded">
                  <tr>
                    <td style="width:5rem">
                      <p-button type="button" pRipple [pRowToggler]="organization" [text]="true" [rounded]="true" [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
                    </td>
                    <td>{{ organization.name }}</td>
                    <td>{{ isValid(organization.authorizedDate) ? ( organization.authorizedDate | date:'mediumDate') : '---' }}</td>
                    <td style="width:3rem">
                      <p-button *ngIf="user.organizations.length > 1" icon="pi pi-times" [text]="true" (click)="onRemoveOrganization($event, organization)" />
                    </td>
                  </tr>
                </ng-template>
                <ng-template #expandedrow let-organization>
                  <tr>
                    <td colspan="7">
                      <app-master-selctabledetail [items]="organization.departments" [isReadOnly]="true"></app-master-selctabledetail>
                      <!--<p-table [value]="organization.departments" dataKey="departmentId" size="small">
                        <ng-template #header>
                          <tr>
                            <th>{{ 'department' | translate }}</th>
                            <th style="width:3rem"></th>
                          </tr>
                        </ng-template>
                        <ng-template #body let-department>
                          <tr>
                            <td>{{ department.name }}</td>
                            <td></td>
                          </tr>
                        </ng-template>
                        <ng-template #emptymessage>
                          <tr>
                            <td colspan="6">There are no departments for this organization yet.</td>
                          </tr>
                        </ng-template>
                      </p-table>-->
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-tabpanel>

        <p-tabpanel [value]="2">
          <div class="grid grid-cols-5 items-center justify-start gap-3">
            <label class="col-start-1 text-left">{{ 'password.current' | translate }}</label>
            <p-password [(ngModel)]="oldValue" [toggleMask]="true" [feedback]="false" fluid />

            <label class="col-start-1 text-left">{{ 'password.new' | translate }}</label>
            <p-password [(ngModel)]="newValue" [toggleMask]="true" fluid>
              <ng-template #footer>
                <p-divider />
                <ul class="my-0 pl-2 text-xs leading-normal">
                  <li>{{ 'password.lowerCase' | translate }}</li>
                  <li>{{ 'password.upperCase' | translate }}</li>
                  <li>{{ 'password.number' | translate }}</li>
                  <li>{{ 'password.length' | translate }}</li>
                </ul>
              </ng-template>
            </p-password>

            <label class="col-start-1 text-left">{{ 'password.confirm' | translate }}</label>
            <p-password [(ngModel)]="chkValue" [toggleMask]="true" fluid>
              <ng-template #footer>
                <p-divider />
                <ul class="my-0 pl-2 text-xs leading-normal">
                  <li>{{ 'password.lowerCase' | translate }}</li>
                  <li>{{ 'password.upperCase' | translate }}</li>
                  <li>{{ 'password.number' | translate }}</li>
                  <li>{{ 'password.length' | translate }}</li>
                </ul>
              </ng-template>
            </p-password>

            <p-button class="col-start-2" [label]="'password.change' | translate" (click)="onChange()" fluid />
          </div>
        </p-tabpanel>

        <p-tabpanel [value]="3">
          <div class="grid grid-cols-5 items-center justify-start gap-3">
            <label class="col-start-1 text-left">{{ 'consents.gdpr' | translate }}</label>
            <p-selectbutton [options]="stateOptions" [(ngModel)]="user.consents.gdprConsent" optionLabel="label" optionValue="value" />
            <p-button class="col-start-3" [label]="'showDocument' | translate" (click)="onShowPrivacy()" />

            <label class="col-start-1 text-left">{{ 'consents.healthData' | translate }}</label>
            <p-selectbutton [options]="stateOptions" [(ngModel)]="user.consents.sanitaryConsent" optionLabel="label" optionValue="value" />

            <label class="col-start-1 text-left">{{ 'consents.terms' | translate }}</label>
            <p-selectbutton [options]="stateOptions" [(ngModel)]="user.consents.tcConsent" optionLabel="label" optionValue="value" />

            <p-divider class="col-start-1 col-end-6" />

            <label class="col-start-1 text-left">{{ 'consents.email' | translate }}</label>
            <p-selectbutton [options]="stateOptions" [(ngModel)]="user.consents.emailConfirmed" optionLabel="label" optionValue="value" [disabled]="true" />
          </div>
        </p-tabpanel>

        <p-tabpanel [value]="4">
          <div class="grid grid-cols-5 items-center justify-start gap-3">
            <label class="col-start-1 text-left">{{ 'functions.ecg' | translate }}</label>
            <p-togglebutton [(ngModel)]="user.features.ecgDisplay" [onLabel]="'active' | translate" [offLabel]="'notAvailable' | translate" disabled="true" />

            <label class="col-start-1 text-left">{{ 'functions.breath' | translate }}</label>
            <p-togglebutton [(ngModel)]="user.features.breath" [onLabel]="'active' | translate" [offLabel]="'notAvailable' | translate" disabled="true" />
            <!--<p-selectbutton [options]="stateOptions" [(ngModel)]="user.features.breath" optionLabel="label" optionValue="value" [disabled]="true" />-->

            <label class="col-start-1 text-left">{{ 'functions.gait' | translate }}</label>
            <p-togglebutton [(ngModel)]="user.features.gait" [onLabel]="'active' | translate" [offLabel]="'notAvailable' | translate" disabled="true" />
            <!--<p-selectbutton [options]="stateOptions" [(ngModel)]="user.features.gait" optionLabel="label" optionValue="value" [disabled]="true" />-->

            <label class="col-start-1 text-left">{{ 'functions.posture' | translate }} {{ 'and' | translate }} {{ 'functions.romberg' | translate }}</label>
            <p-togglebutton [(ngModel)]="user.features.posture" [onLabel]="'active' | translate" [offLabel]="'notAvailable' | translate" disabled="true" />
            <!--<p-selectbutton [options]="stateOptions" [(ngModel)]="user.features.posture" optionLabel="label" optionValue="value" [disabled]="true" />-->

            <label class="col-start-1 text-left">{{ 'functions.hrv' | translate }}</label>
            <p-togglebutton [(ngModel)]="user.features.hrv" [onLabel]="'active' | translate" [offLabel]="'notAvailable' | translate" disabled="true" />
            <!--<p-selectbutton [options]="stateOptions" [(ngModel)]="user.features.hrv" optionLabel="label" optionValue="value" [disabled]="true" />-->

            <label class="col-start-1 text-left">{{ 'functions.afib' | translate }}</label>
            <p-togglebutton [(ngModel)]="user.features.afib" [onLabel]="'active' | translate" [offLabel]="'notAvailable' | translate" disabled="true" />
            <!--<p-selectbutton [options]="stateOptions" [(ngModel)]="user.features.afib" optionLabel="label" optionValue="value" [disabled]="true" />-->
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>

    <ng-template #footer>
      <div class="col-span-3 ml-auto flex gap-2">
        <p-button severity="primary" [label]="'save' | translate" icon="pi pi-check" (click)="onSave()" />
        <p-button severity="secondary" [label]="'primeng.cancel' | translate" icon="pi pi-times" (click)="onCancel()" />
      </div>
    </ng-template>
  </p-card>

  <p-dialog [header]="'consents.privacy' | translate"
            [modal]="true"
            [(visible)]="showPrivacy"
            [style]="{ width: '50%' }"
            [closable]="false" [closeOnEscape]="false"
            [maximizable]="true">

    <ng-template #content>
      <ngx-extended-pdf-viewer [src]="privacyPath"
                               [height]="'65vh'"
                               [zoom]="'auto'"
                               [textLayer]="true"
                               [showHighlightEditor]="false" [showDrawEditor]="false" [showStampEditor]="false" [showTextEditor]="false"
                               [showOpenFileButton]="false" [showPrintButton]="false" [showDownloadButton]="false"
                               [showRotateCwButton]="false" [showRotateCcwButton]="false"
                               [showScrollingButtons]="false" [showSpreadButton]="false" [showPropertiesButton]="false">

      </ngx-extended-pdf-viewer>
    </ng-template>

    <ng-template #footer>
      <p-button [label]="'primeng.aria.close' | translate"
                (click)="showPrivacy = false" />
    </ng-template>
  </p-dialog>
</app-page-base>
